import { Button, Stack } from "~/common/mui";
import { fetchContractsOverview } from "~/features/contracts/api/getContractsOverview";
import { navigateToProductContract } from "~/features/contracts/utils/utils";
import { useState } from "react";

import { useAddToCartFlowContext } from "~/features/addToCart/components/AddToCartProcess/AddToCartFlowContext";
import { Alert } from "~/common/mui/Alert/Alert";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export const ContractAvailableScreen = () => {
  const { t } = useTranslation();
  return <Alert severity={"info"}>{t("popup.atc.contractInfo")}</Alert>;
};

export const ContractLoadErrorScreen = () => {
  const { t } = useTranslation();
  return <Alert severity={"error"}>{t("popup.atc.contractError")}</Alert>;
};

export const ContractButtons = ({
  productDescriptor,
  disabled,
}: {
  productDescriptor: ProductDescriptor;
  disabled?: boolean;
}) => {
  const { continueWithoutContract, markContractLoadErrored } = useAddToCartFlowContext();
  const { t } = useTranslation();
  const isTablet = useIsMinTabletSize();

  const [loading, setLoading] = useState(false);

  return (
    <Stack direction="row" gap={1} className={classNames(!isTablet && "w-100 scha__ellipsis-text")}>
      <Button
        className={classNames(!isTablet && "w-100")}
        color={"secondary"}
        onClick={continueWithoutContract}
        clta-modal-child-marker="without-contract"
      >
        {t("popup.atc.btn.withoutContract")}
      </Button>
      <Button
        className={classNames(!isTablet && "w-100")}
        onClick={async () => {
          setLoading(true);
          try {
            const data = await fetchContractsOverview();
            navigateToProductContract(data, productDescriptor.base.designation);
          } catch {
            markContractLoadErrored();
          }
          setLoading(false);
        }}
        loading={loading}
        disabled={disabled}
        clta-modal-child-marker="with-contract"
      >
        {t("popup.atc.btn.fromContract")}
      </Button>
    </Stack>
  );
};
